<template>
    <member-detail-link :detailLayout="detailLayout" :memberData="memberData"></member-detail-link>
</template>

<script>
    import MemberDetailLink from "@/components/member/MemberDetailLink";
    import memberUtil from "@/components/member/memberUtil";
    import util from "@/mixins/util";
    import alertMixins from "@/mixins/alertMixins";
    import EventBus from "@/utils/event-bus";

    export default {
        name: "MemberDetailComponent",
        mixins: [memberUtil, alertMixins,],
        components: {MemberDetailLink},
        provide() {
            return {
                memberDetailSetData: this.setData,
            }
        },
        inject: ['changeLoading'],
        props: {
            memberType: {default: ''},
            memberKey: {default: 0},
        },
        data() {
            return {
                detailLayout: '',
                getFunc: '',
                detailApiParamSet: {},
                memberData:{},
                languages : [],
            }
        },
        created() {
            this.initConfig();
            this.getDetail();
        },
        mounted() {
            EventBus.$on('memberDetailGet', this.getDetail);
        },
        beforeDestroy() {
            EventBus.$off('memberDetailGet')
        },
        destroyed() {},
        computed: {
        },
        methods: {
            setData(type, value) {
                this[type] = value;
            },

            initConfig() {
                let memberConfig = this.returnMemberConfig(this.memberType);
                this.detailLayout = memberConfig.detailLayout;
                this.getFunc = memberConfig.getFunc;
                this.detailApiParamSet = memberConfig.detailApiParamSet;

            },
            getDetail() {
                if(this.memberKey === 0) {
                    this.createAlert({
                        content: '데이터를 불러올 수 없습니다.',
                        hide: () => {
                            this.$router.back();
                        }
                    })
                }
                let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
                params.no = this.memberKey;
                this.$api.$member[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type != 1 || res.List.length === 0) {
                        this.createAlert({
                            title: '',
                            content: '데이터를 불러올 수 없습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.back();
                            }
                        });
                        return;
                    }
                    this.memberData = res.List[0];
                })
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
